import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

export function Terms() {
  return (
    <div className="min-h-screen bg-[#0a0a12]">
      <Header />
      <main className="pt-32 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-white mb-2">Terms of Service</h1>
          <p className="text-sm text-[#5a4a7a] mb-10">Last updated: March 4, 2026</p>

          <div className="space-y-8 text-[#b0a0c0] leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">1. Acceptance of Terms</h2>
              <p>
                By accessing or using Onyx AI ("the Service"), operated by Cloudforge Studio,
                you agree to be bound by these Terms of Service. If you do not agree, please
                do not use the Service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">2. Description of Service</h2>
              <p>
                Onyx AI provides an AI-powered customer support chatbot platform with features
                including automated chat responses, FAQ management, live agent support, analytics,
                and an embeddable widget for websites.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">3. Account Responsibilities</h2>
              <ul className="list-disc list-inside space-y-1.5 text-[#8a7a9a]">
                <li>You are responsible for maintaining the security of your account credentials</li>
                <li>You must provide accurate and complete registration information</li>
                <li>You are responsible for all activity under your account</li>
                <li>You must notify us immediately of any unauthorized use</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">4. Acceptable Use</h2>
              <p className="mb-3">You agree not to use the Service to:</p>
              <ul className="list-disc list-inside space-y-1.5 text-[#8a7a9a]">
                <li>Transmit spam, malware, or harmful content</li>
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe on intellectual property rights</li>
                <li>Harass, abuse, or harm others</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Use the chatbot for illegal, fraudulent, or deceptive purposes</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">5. Subscription & Billing</h2>
              <ul className="list-disc list-inside space-y-1.5 text-[#8a7a9a]">
                <li>Subscriptions are billed monthly through Stripe</li>
                <li>You may upgrade, downgrade, or cancel at any time</li>
                <li>Downgrades take effect at the end of the current billing period</li>
                <li>Refunds are handled on a case-by-case basis</li>
                <li>We reserve the right to change pricing with 30 days notice</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">6. Data Ownership</h2>
              <p>
                You retain ownership of all content and data you provide to the Service, including
                FAQ entries, chat configurations, and business information. We do not claim ownership
                of your data. Conversation logs are owned by you and can be exported at any time.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">7. Service Availability</h2>
              <p>
                We strive for 99.9% uptime but do not guarantee uninterrupted service.
                Scheduled maintenance will be communicated in advance. We are not liable for
                downtime caused by factors beyond our control.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">8. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, Cloudforge Studio shall not be liable for
                any indirect, incidental, special, or consequential damages arising from your use
                of the Service. Our total liability shall not exceed the amount paid by you in the
                12 months preceding the claim.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">9. Termination</h2>
              <p>
                We may suspend or terminate your account if you violate these terms. You may
                terminate your account at any time by cancelling your subscription and contacting
                support. Upon termination, your data will be retained for 30 days before deletion.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">10. Changes to Terms</h2>
              <p>
                We may update these terms from time to time. Continued use of the Service after
                changes constitutes acceptance of the new terms. Material changes will be
                communicated via email.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">11. Contact</h2>
              <p>
                For questions about these terms, contact us at{" "}
                <a href="mailto:hello.onyx@cloudforge.com.my" className="text-[#c0a0e0] hover:underline">
                  hello.onyx@cloudforge.com.my
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
